import React from "react";
import "./styles.css";
import { Logo } from "../Logo";
import { Button, DropdownButton } from "../Button";
import MobileNavbar from "./MobileNavbar";
import language from "../../language";
import { connect } from "react-redux";
import { ListItem } from "../List";
import { setDefaultLanguage } from "../../actions/Language";
import { getStorage } from "../../utils/storage";
import userPhotoPlaceholder from "../../assets/userPhotoPlaceholder.png";
import { authMenus, nonAuthMenus } from "../../constants/profileMenus";
import icons from "../../constants/icons";
import { NotificationBadgeCount } from "../Notifications";
import { SearchDonor } from "../Donors";
import { Modal } from "../Modal";
// Whichever workspace the account is currently in. Hospital first, since an
// account with both only ever has one hospital selected at a time, while
// `center` may still hold the full list until a choice is made.
const workspaceName = (user) => {
  const centre = Array.isArray(user?.center) ? user.center : [user?.center];
  const centreName =
    user?.centerName || (centre.length === 1 ? centre[0]?.name : undefined);

  // The door decides which name belongs in the bracket. Preferring the
  // hospital unconditionally put a hospital beside a BTD login whose
  // workspace was a centre, so the bracket named somewhere the user was
  // not working.
  if (user?.loginPortal === "btd") return centreName || user?.hospitalName;

  return user?.hospitalName || centreName;
};

class Navbar extends React.Component {
  constructor() {
    super();

    this.mobileNavbarRef = React.createRef();
    this.clockInterval = null;

    this.state = {
      showMoreMenus: false,
      user: {},
      currentTime: new Date(),
    };
  }

  getGreeting() {
    const hour = this.state.currentTime.getHours();
    if (hour >= 5 && hour < 12) return "Good morning";
    if (hour >= 12 && hour < 17) return "Good afternoon";
    if (hour >= 17 && hour < 21) return "Good evening";
    return "Good evening";
  }

  getWish() {
    const hour = this.state.currentTime.getHours();
    if (hour >= 5 && hour < 12) return "Have a productive day";
    if (hour >= 12 && hour < 17) return "Have a great afternoon";
    if (hour >= 17 && hour < 21) return "Have a pleasant evening";
    return "Have a good night";
  }

  formatTime() {
    return this.state.currentTime.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });
  }

  formatDate() {
    return this.state.currentTime.toLocaleDateString([], {
      weekday: "short",
      month: "short",
      day: "numeric",
      year: "numeric",
    });
  }

  componentDidMount = async () => {
    const user = await getStorage();

    this.setState({ user });

    this.clockInterval = setInterval(() => {
      this.setState({ currentTime: new Date() });
    }, 1000);

    document.addEventListener("mousedown", this.handleClickOutside.bind(this));

    window.addEventListener("scroll", this.onScroll.bind(this), {
      capture: true,
    });
  };

  componentWillUnmount() {
    clearInterval(this.clockInterval);
    document.removeEventListener("mousedown", this.handleClickOutside.bind(this));
    window.removeEventListener("scroll", this.onScroll.bind(this), { capture: true });
  }

  onScroll() {
    var landingContainer = document.getElementById("landingContainer");

    const scrollY = landingContainer?.scrollTop;

    const navbar_container = document.getElementById("navbar-container");

    if (navbar_container && navbar_container.classList && scrollY) {
      let nav_class_list = navbar_container.classList;

      if (scrollY > 100) {
        if (navbar_container) {
          nav_class_list.add("navbar-sticky-top");
          nav_class_list.add("text-color-dark");
        }
      } else {
        nav_class_list.remove("navbar-sticky-top");
        nav_class_list.remove("text-color-dark");
      }
    }
  }

  handleShowMoreMenus = (e) => {
    e.preventDefault();

    const { type } = this.props;

    if (type === "dashboard") {
      return this.handleToggleSidebar();
    }
    this.setState({ showMoreMenus: !this.state.showMoreMenus });
  };

  handleToggleSidebar() {
    const container = document.getElementById("sidebar-container");

    if (container && container.classList) {
      let nav_class_list = container.classList;

      if (container && nav_class_list.contains("hide")) {
        nav_class_list.add("show");
        nav_class_list.remove("hide");
      } else if (container && nav_class_list.contains("show")) {
        nav_class_list.add("hide");
        nav_class_list.remove("show");
      }
    }
  }

  handleClickOutside(event) {
    if (
      this.mobileNavbarRef.current &&
      !this.mobileNavbarRef.current.contains(event.target) &&
      this.state.showMoreMenus
    ) {
      this.setState({ showMoreMenus: false });
    }
  }

  handleShowModal(modal) {
    this.setState({
      [modal]: true,
    });
  }

  handleCloseModal(modal) {
    this.setState({
      [modal]: false,
    });
  }

  render() {
    return (
      <>
        <nav
          className={`landing-navbar-container ${
            this.props.isFixed ? "nav-fixed" : ""
          }

           ${this.props.isMenuLight ? "nav-menu-light" : ""}
           ${this.props.isShadowActive ? "navbar-shadow" : ""}
           ${this.props.isLight ? "nav-light" : ""}
           ${this.props.isTransparent ? "nav-transparent" : ""}`}
          id="navbar-container"
        >
          <div
            className={`${
              this.props.className || "container"
            } menu-landing-container `}
          >
            <div className="left-container">
              <Logo
                className="light"
                handleMenuIconClicked={this.handleShowMoreMenus.bind(this)}
                type={this.props.type}
              />
            </div>
            <div className="right-container">
              {this.state.user.token && this.state.user.account_type !== "donor" && this.state.user.role !== "donor" && (
                <div className="navbar-greeting-block hidden-xs hidden-sm">
                  <div className="navbar-greeting-text">
                    <span className="navbar-greeting-hello">
                      {this.getGreeting()}, <strong>{this.state.user.displayName?.split(" ")[0] || "User"}</strong>
                    </span>
                    <span className="navbar-greeting-wish">{this.getWish()}</span>
                  </div>
                  <div className="navbar-greeting-divider" />
                  <div className="navbar-greeting-clock">
                    <span className="navbar-greeting-time">{this.formatTime()}</span>
                    <span className="navbar-greeting-date">{this.formatDate()}</span>
                  </div>
                </div>
              )}
              {this.state.user.token && this.state.user.account_type !== "donor" && this.state.user.role !== "donor" && (
                <>
                  {/* <DropdownButton
                    text={language[this.props.defaultLanguage].find_application}
                    className="btn-sm btn-transparent bordered"
                    leftIcon={icons.search}
                  >
                    <ListItem
                      name={
                        language[this.props.defaultLanguage]
                          .start_new_application
                      }
                      onPress={() =>
                        (window.location.href =
                          "/blood-donation-assessment/start-application")
                      }
                      icon={icons.add}
                    />
                    <ListItem
                      name={language[this.props.defaultLanguage].existing_donor}
                      onPress={() =>
                        this.handleShowModal("showSearchDonorModal")
                      }
                      icon={icons.user}
                    />
                  </DropdownButton> */}
                  <div
                    className="navbar-notification-container"
                    onClick={() =>
                      (window.location.href =
                        this.state.user.role === "user"
                          ? "/public-servant/notifications"
                          : "/dashboard/notifications")
                    }
                  >
                    <Button
                      className="btn-transparent light"
                      icon={icons.notification}
                    />
                    <NotificationBadgeCount
                      // count={2}
                      borderClassName="primary-border"
                      styles={{
                        position: "absolute",
                      }}
                    />
                  </div>
                </>
              )}
              <div className="hidden-xs hidden-sm d-flex">
                {nonAuthMenus(this.props.defaultLanguage)?.map((menu, i) => {
                  if (
                    this.state.user.token &&
                    menu.access.includes("protected")
                  ) {
                    return (
                      <Button
                        type="hyperlink"
                        to={menu.route}
                        key={i}
                        text={menu.name}
                        styles={{ minWidth: 100, minHeight: 35 }}
                        className={`btn-transparent ${
                          this.props.isMenuLight ? "light" : ""
                        }`}
                      />
                    );
                  } else if (
                    !this.state.user.token &&
                    menu.access.includes("public")
                  ) {
                    return (
                      <Button
                        type="hyperlink"
                        to={menu.route}
                        key={i}
                        text={menu.name}
                        styles={{ minWidth: 100, minHeight: 35 }}
                        className={`btn-transparent ${
                          this.props.isMenuLight ? "light" : ""
                        }`}
                      />
                    );
                  }
                  return null;
                })}

                <DropdownButton
                  text={this.props.defaultLanguage}
                  className={`btn-transparent black ${
                    this.props.isMenuLight ? "light" : ""
                  }`}
                  leftImage={language[this.props.defaultLanguage].image}
                >
                  {Object.keys(language).map((key, i) => {
                    return (
                      <ListItem
                        key={i}
                        name={key}
                        onPress={() =>
                          this.props.dispatch(setDefaultLanguage(key))
                        }
                        image={language[key].image}
                      />
                    );
                  })}
                </DropdownButton>
              </div>
              {this.state.user.token ? (
                <>
                  <DropdownButton
                    text={`${this.state.user.displayName}${
                      // BTD staff work out of a centre, facility staff out
                      // of a hospital. Either way the bracket says where
                      // the data on screen is scoped to.
                      workspaceName(this.state.user)
                        ? " (" + workspaceName(this.state.user) + ")"
                        : ""
                    }`}
                    className="btn-transparent black menu-container-no-shadow"
                    leftImage={userPhotoPlaceholder}
                  >
                    {authMenus(this.props.defaultLanguage, this.state.user).map((el, i) => {
                      return (
                        <ListItem
                          key={i}
                          name={el.name}
                          onPress={el.onPress}
                          icon={el.icon}
                          iconClassName="sm"
                        />
                      );
                    })}
                  </DropdownButton>
                </>
              ) : (
                <Button
                  text={language[this.props.defaultLanguage].login_text}
                  styles={{ minWidth: 100, minHeight: 35 }}
                  onPress={() => (window.location.href = "/login")}
                />
              )}
            </div>
          </div>
          <MobileNavbar
            ref={this.mobileNavbarRef}
            className={this.state.showMoreMenus ? "show" : "hide"}
            {...this.props}
            user={this.state.user}
          />
        </nav>
        <Modal
          handleClose={this.handleCloseModal.bind(this, "showSearchDonorModal")}
          show={this.state.showSearchDonorModal}
          title={language[this.props.defaultLanguage].search_donor}
        >
          <SearchDonor
            handleCloseModal={this.handleCloseModal.bind(
              this,
              "showSearchDonorModal",
            )}
          />
        </Modal>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return {
    defaultLanguage,
  };
};

export default connect(mapStateToProps)(Navbar);
